var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "invoice",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.469,
    height: 19.788,
    viewBox: "0 0 15.469 19.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18790",
    "data-name": "Path 18790",
    d: "M15.391,0H.907A.492.492,0,0,0,.414.492V19.3a.492.492,0,0,0,.826.362l1.713-1.58a.491.491,0,0,1,.662-.005l1.123,1a1.476,1.476,0,0,0,1.973-.005l1.107-1a.491.491,0,0,1,.66,0l1.107,1a1.475,1.475,0,0,0,1.973.005l1.123-1a.491.491,0,0,1,.662.005l1.713,1.58a.493.493,0,0,0,.826-.362V.492A.493.493,0,0,0,15.391,0ZM14.9,18.172l-.887-.818a1.473,1.473,0,0,0-1.985-.016l-1.123,1a.492.492,0,0,1-.658,0l-1.107-1a1.474,1.474,0,0,0-1.979,0l-1.107,1a.492.492,0,0,1-.658,0l-1.123-1a1.472,1.472,0,0,0-1.985.016l-.887.818V.985H14.9V18.172Zm0,0",
    transform: "translate(-0.414)",
    fill: "#9f9f9f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18791",
    "data-name": "Path 18791",
    d: "M81.121,136.766h6.321a.492.492,0,1,0,0-.985H81.121a.492.492,0,1,0,0,.985Zm0,0",
    transform: "translate(-76.679 -129.095)",
    fill: "#9f9f9f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18792",
    "data-name": "Path 18792",
    d: "M81.121,206.286h6.321a.492.492,0,0,0,0-.985H81.121a.492.492,0,1,0,0,.985Zm0,0",
    transform: "translate(-76.679 -195.191)",
    fill: "#9f9f9f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.6cc0442c5cc2e242f374a3c8486a7efc.svg";
export { ForwardRef as ReactComponent };